import AverageRaitingBox from "./AverageRaitingBox"
import RatingBar from "./RatingBar"

const RatingSection = ({doctor}) => {

    const rates = [
        {
            title:'نحوه برخورد پزشک',
            score: doctor.score,
        },
        {
            title:'نحوه برخورد پزشک',
            score: doctor.score,
        },
        {
            title:'نحوه برخورد پزشک',
            score: doctor.score,
        },
        {
            title:'نحوه برخورد پزشک',
            score: doctor.score,
        },
        {
            title:'نحوه برخورد پزشک',
            score: doctor.score,
        },
    ]

    return(
        <div
        className="flex justify-between gap-5 bg-white p-5 rounded-[15px]"
        >
             <div
             className="w-3/5 flex flex-col gap-5"
             >
                {rates.map((rate)=>(
                    <RatingBar
                    rating={rate.score}
                    title={rate.title}
                    />
                ))}
             </div>
                <AverageRaitingBox
                doctor={doctor}
                />
        </div>
    )
}
export default RatingSection 